import get from 'lodash/get';
import omit from 'lodash/omit';
import { Form } from 'react-bootstrap';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { ApiError } from '../../../api';
import { ShowFieldErrors } from '../../../utils/forms';
import { FormFeedback } from '../FormFeedback';
import { FormFieldVisibility, FormLabel } from '../FormLabel';

interface FormSelectFieldProps {
  name: string;
  label: string;
  options: { [key: string]: string };
  serverErrors?: ApiError;
  showServerFieldErrors: ShowFieldErrors;
  setShowServerFieldErrors: (showServerFieldErrors: ShowFieldErrors) => void;
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  extraFieldErrorsToHideOnChange?: string[];
  required?: boolean;
  srOnlyLabel?: boolean;
  visibility?: FormFieldVisibility;
  placeholder?: string;
}

export const FormSelectField = ({
  name,
  label,
  options,
  serverErrors,
  showServerFieldErrors,
  setShowServerFieldErrors,
  errors,
  register,
  extraFieldErrorsToHideOnChange = [],
  required = false,
  srOnlyLabel = false,
  visibility,
  placeholder,
  ...rest
}: FormSelectFieldProps & Parameters<typeof Form.Select>[0]) => (
  <Form.Group className="mb-3" controlId={name}>
    <FormLabel required={required} visibility={visibility} srOnlyLabel={srOnlyLabel}>
      {label}
    </FormLabel>
    <Form.Select
      {...register(name, {
        onChange: () =>
          setShowServerFieldErrors({
            ...omit(showServerFieldErrors, [name, ...extraFieldErrorsToHideOnChange]),
          }),
      })}
      {...rest}
      isInvalid={!!get(errors, name) || !!get(showServerFieldErrors, name)}
    >
      <option className="d-none" value="" disabled>
        {placeholder || 'Choose One'}
      </option>
      {Object.keys(options).map((key) => (
        <option key={key} value={key}>
          {options[key]}
        </option>
      ))}
    </Form.Select>
    <FormFeedback
      clientError={get(errors, name)}
      serverErrors={get(showServerFieldErrors, name) ? get(serverErrors?.body, name) : null}
    />
  </Form.Group>
);
